"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOM = exports.CopyBlock = exports.Align = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
var _DynamicHeading = require("../DynamicHeading");
var _LexusTypography = require("../LexusTypography");
var _Typography = require("../Typography");
const Align = exports.Align = _styledComponents.default.div`
  ${(0, _breakpoints.default)("desktop", "up")} {
    text-align: ${function (_ref) {
  let {
    desktop = "left"
  } = _ref;
  return desktop;
}};
  }
  ${(0, _breakpoints.default)("tablet", "up")} {
    text-align: ${function (_ref2) {
  let {
    tablet = "left"
  } = _ref2;
  return tablet;
}};
  }
  text-align: ${function (_ref3) {
  let {
    mobile = "center"
  } = _ref3;
  return mobile;
}};
`;
const fontFamilyByWeight = function () {
  let weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "normal";
  if (weight === "bold") {
    return "nobel-bold";
  }
  if (weight === "book") {
    return "nobel-book";
  }
  if (weight === "light") {
    return "nobel-light";
  }
  return "nobel-regular";
};
const CopyBlock = exports.CopyBlock = (0, _Typography.StyledType)("div", function /* props */
() {
  // If we need the theme here for GR styling, it is possible:
  // const theme = useTheme()
  return {
    family: "nobel-book",
    size: "body1"
  };
})`
  h1, h2, h3, h4, h5 {
    font-weight: normal;
  }

  p {
    margin: 0 0 15px;
  }

  strong,
  b {
    font-family: nobel-bold;
  }

  * + a,
  * + button,
  p + a,
  p + button {
    margin: 0 0 50px;
  }

  > *:last-child,
  > div:last-child > *:last-child {
    margin-bottom: 0;
  }
  
  ${function (_ref4) {
  let {
    $transparentBackground
  } = _ref4;
  return $transparentBackground && `
    background: transparent !important;
  `;
}}
`;
const DOM = exports.DOM = {
  p: (0, _Typography.StyledType)("p", function (_ref5) {
    let {
      weight = "book",
      size = "body1",
      letterSpacing = "normal"
    } = _ref5;
    return {
      family: fontFamilyByWeight(weight),
      size,
      letterSpacing
    };
  })`
    ${function (_ref6) {
    let {
      weight
    } = _ref6;
    return weight === "bold" && `
      a {
        text-decoration-thickness: 1px;
        text-underline-offset: 2px;
        letter-spacing: 0.1em;
        ${_Typography.sizes.linkCopy1}
      }
    `;
  }}
  `,
  h1: (0, _Typography.StyledType)(_DynamicHeading.H1, function (_ref7) {
    let {
      weight = "normal",
      size = "heading5",
      letterSpacing
    } = _ref7;
    return {
      family: fontFamilyByWeight(weight),
      size,
      letterSpacing
    };
  })`
    margin: 0 0 25px;
  `,
  h2: (0, _Typography.StyledType)(_DynamicHeading.H2, function (_ref8) {
    let {
      weight = "normal",
      size = "subHeader2",
      letterSpacing
    } = _ref8;
    return {
      family: fontFamilyByWeight(weight),
      size,
      letterSpacing
    };
  })`
    margin: 0 0 25px;
  `,
  h3: (0, _Typography.StyledType)(_DynamicHeading.H3, function (_ref9) {
    let {
      weight = "normal",
      size = "subHeader3",
      letterSpacing
    } = _ref9;
    return {
      family: fontFamilyByWeight(weight),
      size,
      letterSpacing
    };
  })`
    margin: 0 0 25px;
  `,
  h4: (0, _Typography.StyledType)(_DynamicHeading.H4, function (_ref10) {
    let {
      weight = "normal",
      size = "bodyCopy1",
      letterSpacing
    } = _ref10;
    return {
      family: fontFamilyByWeight(weight),
      size,
      letterSpacing
    };
  })`
    margin: 0 0 25px;
  `,
  h5: (0, _Typography.StyledType)(_DynamicHeading.H5, function (_ref11) {
    let {
      weight = "normal",
      size = "linkCopy",
      letterSpacing
    } = _ref11;
    return {
      family: fontFamilyByWeight(weight),
      size,
      letterSpacing
    };
  })`
    margin: 0 0 25px;
  `,
  small: (0, _Typography.StyledType)("small", function (_ref12) {
    let {
      weight = "normal",
      size = "legalCopy1",
      letterSpacing = "normal"
    } = _ref12;
    return {
      family: fontFamilyByWeight(weight),
      size,
      letterSpacing
    };
  })`
    display: inline-block;
  `,
  ul: _styledComponents.default.ul`
    ${(0, _breakpoints.default)("mobile")} {
      columns: 1 !important;
    }
  `,
  DOM: {
    p: (0, _Typography.StyledType)("p", function (_ref13) {
      let {
        weight = "book",
        size = "body1",
        letterSpacing = "normal"
      } = _ref13;
      return {
        family: fontFamilyByWeight(weight),
        size,
        letterSpacing
      };
    })`
      ${function (_ref14) {
      let {
        weight
      } = _ref14;
      return weight === "bold" && `
        a {
          text-decoration-thickness: 1px;
          text-underline-offset: 2px;
          letter-spacing: 0.1em;
          ${_Typography.sizes.linkCopy1}
        }
      `;
    }}
    `,
    h1: (0, _styledComponents.default)(_DynamicHeading.H1)`
      ${(0, _LexusTypography.nobel)({
      weight: "regular",
      sizing: "heading35"
    })}
      margin: 0 0 25px;
    `,
    h2: (0, _styledComponents.default)(_DynamicHeading.H2)`
      ${(0, _LexusTypography.nobel)({
      weight: "regular",
      sizing: "subheading18_26"
    })}
      margin: 0 0 25px;
    `,
    h3: (0, _styledComponents.default)(_DynamicHeading.H3)`
      ${(0, _LexusTypography.nobel)({
      weight: "regular",
      sizing: "subheading16"
    })}
      margin: 0 0 25px;
    `,
    h4: (0, _styledComponents.default)(_DynamicHeading.H4)`
      ${(0, _LexusTypography.nobel)({
      weight: "regular",
      sizing: "body14"
    })}
      margin: 0 0 25px;
    `,
    h5: (0, _styledComponents.default)(_DynamicHeading.H5)`
      ${(0, _LexusTypography.nobel)({
      weight: "regular",
      size: "link13"
    })}
      margin: 0 0 25px;
    `,
    small: (0, _Typography.StyledType)("small", function (_ref15) {
      let {
        weight = "normal",
        size = "legalCopy1",
        letterSpacing = "normal"
      } = _ref15;
      return {
        family: fontFamilyByWeight(weight),
        size,
        letterSpacing
      };
    })`
      display: inline-block;
    `,
    ul: _styledComponents.default.ul`
      ${(0, _breakpoints.default)("mobile")} {
        columns: 1 !important;
      }
    `
  }
};